import { CSSProperties, FC } from 'react';

export const TriangleDownIcon: FC<{ className?: string; style?: CSSProperties }> = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    width="12"
    height="12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="10.8 8 10.39 9"
  >
    <g filter="url(#filter0_d_1280_257380)">
      <path d="M16.0008 17L21.197 8L10.8047 8L16.0008 17Z" fill="currentColor"></path>
    </g>
    <defs>
      <filter
        id="filter0_d_1280_257380"
        x="0.804688"
        y="0"
        width="30.3926"
        height="29"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        ></feColorMatrix>
        <feOffset dy="2"></feOffset>
        <feGaussianBlur stdDeviation="5"></feGaussianBlur>
        <feComposite in2="hardAlpha" operator="out"></feComposite>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1280_257380"></feBlend>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1280_257380" result="shape"></feBlend>
      </filter>
    </defs>
  </svg>
);
